import styles from '../../AdventureCardDsl.module.scss'
import CardDsl from '../CardDsl'
import { CourseInclusions } from '../AdventureCardInclusions'
import CardPrice from '../CardPrice'
import PropTypes from 'prop-types'

const PaperCard = ({
  adventure,
  isHighlighted,
  isCourse,
  activityPage,
  isWidget,
  externalPage,
  isBlocked,
  wechatQr,
}) => {
  return (
    <CardDsl adventure={adventure} isHighlighted={isHighlighted} activityPage={activityPage}>
      <strong className={styles.title}>{adventure.title}</strong>
      <CourseInclusions infoType='paper' item={adventure} />
      <CardPrice
        adventure={adventure}
        type='paper'
        isWidget={isWidget}
        isCourse={isCourse}
        isBlocked={isBlocked}
        activityPage={activityPage}
        externalPage={externalPage}
        wechatQr={wechatQr}
      />
    </CardDsl>
  )
}

export default PaperCard

PaperCard.propTypes = {
  adventure: PropTypes.object,
  isHighlighted: PropTypes.bool,
  isCourse: PropTypes.bool,
  activityPage: PropTypes.string,
  isWidget: PropTypes.bool,
  externalPage: PropTypes.string,
  isBlocked: PropTypes.bool,
  wechatQr: PropTypes.string,
}
